
import { StyleValue, defineComponent } from 'vue';
import { ActionTypes } from '@/store/actionTypes';
import { LocationBeggingModalOptions } from '@/store/types';
import FbxButton from './fbx-button.vue';

export default defineComponent({
    name: 'LocationBeggingModal',
    components: {
        FbxButton,
    },
    emits: ['continue'],
    props: {
        isInformational: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        contentStyle(): StyleValue {
            return {
                '--max-height': this.isInformational ? '1000px' : '160px',
            };
        },
    },
    methods: {
        closeModal(): void {
            const options = new LocationBeggingModalOptions({
                modalShown: false,
            });

            this.$store.dispatch(
                ActionTypes.SHOW_LOCATION_BEGGING_MODAL,
                options
            );
        },
    },
});
